import React from 'react';
import { ImageCouldFromRemoteServer as Image } from '@/components/images'
import { useRouter } from '@/navigation';
import { useTranslations } from 'next-intl';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import { KafkaNote } from '@nf/utils-common/constants';
import { ViewEnum } from '@/types';
import { useAppearanceStore } from '@/store/appearance';
import { useSiteStore } from '@/store/site';
import { useAccountInfo } from '@/hooks/query/account';
interface BetbySliderProps {
	onClose: () => void;
}

export const BetbySlider: React.FC<BetbySliderProps> = ({
	onClose,
}) => {
	const router = useRouter();
	const t = useTranslations('General');
	const { user } = useAccountInfo();
	const view = useAppearanceStore(state => state.view);
	const [setCurrentPage] = useSiteStore(state => [state.setCurrentPage]);

	const handleClickButton = async () => {
		setKafkaNormal({
			note: KafkaNote.Betby,
			type: view == ViewEnum.mars ? 1 : 2,
			action: 6,
		});
		setCurrentPage('lbl_VirtualSport');
		router.push('/sports/134');
		onClose();
	};

	return (
		<div className="betby-modal">
			<Image
				src="/images/promotion-activity-modal/betby-slider/betby-slider-bg.png"
				alt=""
				width="480"
				height="360"
				className="betby-modal__bg"
				isGalaxyFolder={true}
			/>
			<Image
				src="/images/promotion-activity-modal/betby-slider/betby-slider-promo.png"
				alt=""
				width="288"
				height="360"
				className="betby-modal__bg"
				isGalaxyFolder={true}
			/>
			<div className="betby-modal__content">
				<div className="betby-modal__title" data-storke={`${t('lbl_BetbyPopup01')} ${t('lbl_BetbyPopup02')}`}>
					{t('lbl_BetbyPopup01')} {t('lbl_BetbyPopup02')}
				</div>
				<div className="betby-modal__subTitle" data-storke={t('lbl_BetbyPopup03')}>
					{t('lbl_BetbyPopup03')}
				</div>
				<Image
					src="/images/promotion-activity-modal/betby-slider/betby-slider-divider.png"
					alt=""
					width="256"
					height="15"
					className="betby-modal__divider"
					isGalaxyFolder={true}
				/>
				<div className="betby-modal__desc">
					{t('lbl_BetbyPopup04')}
				</div>
			</div>
			<div className="betby-modal__footer">
				{user?.LicenseeSiteSetting?.EnableBetbyBasketball2K && (
					<button 
						className="betby-modal__btn" 
						onClick={handleClickButton}
					>
						{t('lbl_PlayNow')}
					</button>
				)}
			</div>
		</div>
	);
};